module.exports = __webpack_public_path__ + "assets/img/i9.1a3206d5.png";